import useMediaQuery from "@mui/material/useMediaQuery";
import { theme } from "../css/theme";
import { useRef } from "react";
import { useEffect } from "react";
import Moment from "moment";
import { ROUTE_HOME } from "./../constants/routes";

export const contains = (array, item) => {
  return array.indexOf(item) !== -1;
};

export const copyObject = (ob) => {
  return JSON.parse(JSON.stringify(ob));
  // let newObject = Object.assign({}, ob);
  // return newObject;
};

export const IsMobile = () => {
  return useMediaQuery(theme.breakpoints.down("sm"));
};
export const IsTablet = () => {
  return useMediaQuery(theme.breakpoints.down("md"));
};

export const isImageFile = (fileName) => {
  const imgExtension = [".jpg", ".gif", ".png", ".gif"];
  const pattern = "(" + imgExtension.join("|").replace(/\./g, "\\.") + ")$";
  return new RegExp(pattern, "i").test(fileName);
};

export const downloadLink = (url, name) => {
  var link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", name);
  link.style.visibility = "hidden";
  document.body.appendChild(link); // Required for FF
  link.click();
  document.body.removeChild(link);
};

export const isEmail = (mail) => {
  // return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
  // check for @
  var atSymbol = mail.indexOf("@");
  if (atSymbol < 1) return false;

  var dot = mail.indexOf(".");
  if (dot === -1) return false;

  return true;
};

export const isSessionExpiredError = (e) => {
  return e && e.response && e.response.status === 401;
};
export const isNotFoundError = (e) => {
  return e && e.response && e.response.status === 404;
};

export const isNumber = (n) => {
  return !isNaN(parseFloat(n)) && !isNaN(n - 0);
};

export const numberWithPoints = (x) => {
  let resp = "-";
  if (x !== undefined && x !== null) {
    //redondeamos
    const number = roundNumber(parseFloat(x));
    resp = Math.trunc(number)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    //pegamos la parte decimal
    let sections = number.toString().split(".");
    if (sections.length > 1) {
      resp = `${resp},${sections[1]}`;
    }
  }
  return resp;

  // return x !== undefined && x !== null ? parseInt(x).toLocaleString("es") : "-";
  // return x !== undefined && x !== null
  //   ? (Math.round(parseFloat(x) * 100) / 100).toLocaleString("en")
  //   : "-";
};

export const isResponseError = (response) => {
  return !response || response.result === "ERROR" || (response.data && response.data.result === "ERROR");
};

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export function convertHex(hex, opacity) {
  hex = hex.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
}

/**
 * Reduce array of objects with object with same
 * field acumulate in filterValue array
 * @param {{field:string, filterValue:any}[]} filter
 * @return {any[]} filtered reduced array by field value [{[field]:[fieldValues]}]
 */
export const reduceFilter = (filter) => {
  return filter.reduce((acc, d) => {
    const field = d.field;
    const found = acc.find((f) => f[field] !== undefined);
    if (!found) {
      acc.push({
        [field]: d.filterValue,
      });
    } else {
      const oldValue = found[field];
      if (Array.isArray(oldValue)) {
        oldValue.push(d.filterValue);
      } else {
        found[field] = [oldValue, d.filterValue];
      }
    }
    return acc;
  }, []);
};

export const isFirstRoutePrimary = (route) => {
  return [ROUTE_HOME].indexOf(route) !== -1;
};

export const getServerErrorMessage = (t, e) => {
  console.log("e.response: ", e.response);
  if (e && e.response && e.response.data && e.response.data.message) {
    return t(`serverErrors.${e.response.data.message}`, t("errors.unexpectedError"));
  }

  if (e && e.response && e.response.data && e.response.data.ERROR && !Array.isArray(e.response.data.ERROR)) {
    return t(`serverErrors.${e.response.data.ERROR}`, t("errors.unexpectedError"));
  }
  if (e && e.response && e.response.data && e.response.data.ERROR && Array.isArray(e.response.data.ERROR)) {
    return e.response.data.ERROR.map((e) => t(`serverErrors.${e}`, t("errors.unexpectedError"))).join(", ");
  }
  if (e && e.response && e.response.data) {
    return t(`serverErrors.${e.response.data}`, t("errors.unexpectedError"));
  }
  return t("errors.unexpectedError");
};
export const getServerErrorCode = (e) => {
  return e && e.response && e.response.data ? e.response.data.message : null;
};
export const humanFileSize = (bytes, dp = 0) => {
  const thresh = 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

  return bytes.toFixed(dp) + " " + units[u];
};

export const getTreeNodeOptions = (tree) => {
  let options = [];
  const iterateTree = (tree, parentIndex) => {
    tree.forEach((node, index) => {
      let treeIndex = index + 1;
      options.push({
        value: node.id,
        text: `${parentIndex ? `${parentIndex}.` : ""}${treeIndex} ${node.title}`,
      });
      if (node.children) {
        return iterateTree(node.children, `${parentIndex ? `${parentIndex}.` : ""}${treeIndex}`);
      }
    });
    return tree;
  };
  iterateTree(tree);
  return options;
};
export const getTreeNodeExpanded = (tree) => {
  let expanded = [];
  const iterateTree = (tree) => {
    tree.forEach((node) => {
      if (node.expanded) {
        expanded.push(node.id);
      }
      if (node.children) {
        return iterateTree(node.children);
      }
    });
    return tree;
  };
  iterateTree(tree);
  return expanded;
};

export const setTreeNodeExpanded = (tree, expandedIds) => {
  const iterateTree = (tree) => {
    tree.forEach((node, index) => {
      if (expandedIds.indexOf(node.id) !== -1) {
        tree[index].expanded = true;
      }
      if (node.children) {
        return iterateTree(node.children);
      }
    });
    return tree;
  };
  return iterateTree(tree);
};
export const getServerErrorStatus = (e, t) => {
  return e && e.response ? e.response.status : null;
};

export const showColumn = (data, column) => {
  return data.indexOf(column) === -1;
};
export const getDiffDays = (startDate, endDate) => {
  let resp = null;
  if (startDate && endDate) {
    const momentStartDate = Moment(startDate);
    const momentEndDate = Moment(endDate);

    resp = momentEndDate.diff(momentStartDate, "days"); // =1
  }
  return resp;
};

export const agendaNumberSortable = (agNumber) => {
  let resp = 0;
  if (agNumber) {
    let d = 1;
    agNumber.split(".").forEach((n) => {
      resp = resp + n * d;
      d = d / 10;
    });
  }

  return resp;
};

export const getWeightedAverage = (data, services, profiles) => {
  let resp = 0;
  if (services.find((s) => s.getId() === data.serviceId)) {
    profiles.forEach((p) => {
      resp += ((data[p.getId()] || 0) * p.getWeight()) / 100;
    });
  }
  // return roundNumber(resp);
  return resp;
};

export const roundNumber = (num, decimals) => {
  const n = decimals ? 10 * decimals : 100;
  return Math.round(num * n) / n;
  // return n.toPrecision(decimals || 2);
};

export const hideError = (e) => {
  if (e.message === "ResizeObserver loop completed with undelivered notifications.") {
    const resizeObserverErrDiv = document.getElementById("webpack-dev-server-client-overlay-div");
    const resizeObserverErr = document.getElementById("webpack-dev-server-client-overlay");
    if (resizeObserverErr) {
      resizeObserverErr.setAttribute("style", "display: none");
    }
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.setAttribute("style", "display: none");
    }
  }
};

export const sumArrayObjectProperty = (items, prop) => {
  return items.reduce(function (a, b) {
    return a + (b[prop] || 0);
  }, 0);
};
